import { getCountryCallingCode } from "react-phone-number-input/input"

const prepareData = (data) => {
  const { phone, name, email, country, project, channel } = data
  const phoneQuery = phone.length
    ? `phoneNumber: "+${getCountryCallingCode(country)}${phone}",`
    : ""

  const emailQuery = email.length ? `email:"${email.trim()}",` : ""

  const subscribeBlog =
    project.indexOf("blog") > -1
      ? `subscribeBlog: ${!!project.splice(project.indexOf("blog"), 1)},`
      : ""
  const projects = project.length ? `,project: [${project}]` : ""
  return `${phoneQuery} name:"${name}", ${emailQuery} ${subscribeBlog} channel: ${channel} ${projects}`
}

const postSubscription = async (data) => {
  const dataQuery = prepareData(data)

  const response = await fetch(process.env.GATSBY_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Basic  ${process.env.GATSBY_API_BASE_AUTH}`,
    },
    body: JSON.stringify({
      query: `mutation{
                  subscribe(data: {${dataQuery}}) {
                    ok
                  }
                }`,
      variables: null,
    }),
  })
  const body = await response.json()
  return body
}

export default postSubscription
